module.exports = __webpack_public_path__ + "img/logo_black.2fd4b3e4.png";